import Stack from '@mui/material/Stack';
import NotesImg from '../../assets/images/generic/notes.png';
import Typography from '@mui/material/Typography';
import { Trans } from 'react-i18next';
import { Arrow } from '../Faqs.jsx';
import React from 'react';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Accordion from '@mui/material/Accordion';

export default function ExplanationContainer({ titleI18n, subtitleI18n }) {
    return (
        <>
            <Stack
                sx={{
                    backgroundColor: '#EBEBFF',
                    borderRadius: 4,
                    alignItems: 'center',
                    display: { xs: 'none', md: 'flex' },
                }}
                direction="row"
                spacing={2}
                p={2}
            >
                <img height={48} width={48} src={NotesImg} alt="notes" />
                <Stack>
                    <Typography variant="body4">
                        <Trans i18nKey={titleI18n} />
                    </Typography>
                    <Typography sx={{ lineHeight: '22px' }} variant="caption">
                        <Trans i18nKey={subtitleI18n} />
                    </Typography>
                </Stack>
            </Stack>

            <Accordion
                sx={{
                    display: { xs: 'block', md: 'none' },
                    backgroundColor: '#EBEBFF',
                    borderRadius: 4,
                    boxShadow: 'none',
                    padding: 0,
                    margin: 0,
                    '&:before': {
                        display: 'none',
                    },
                }}
            >
                <AccordionSummary
                    expandIcon={
                        <span style={{ marginTop: '6px' }}>
                            <Arrow />
                        </span>
                    }
                    sx={{ overflow: 'auto' }}
                >
                    <Stack direction={'row'} alignItems={'center'} spacing={1}>
                        <img height={33} width={33} src={NotesImg} alt="notes" />
                        <Typography variant="body4">
                            <Trans i18nKey={titleI18n} />
                        </Typography>
                    </Stack>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography sx={{ lineHeight: '15px' }} variant="caption">
                        <Trans i18nKey={subtitleI18n} />
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </>
    );
}
